var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgExtractValue = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13C10.3431 13 9 11.9255 9 10.6C9 9.27452 10.3431 8.2 12 8.2M12 13C13.6568 13 15 14.0745 15 15.4C15 16.7255 13.6569 17.8 12 17.8M12 13V8.2M12 13L12 17.8M12 8.2C13.1104 8.2 14.0799 8.68264 14.5986 9.4M12 8.2V7M12 17.8L12 19M12 17.8C10.8896 17.8 9.92007 17.3174 9.40137 16.6",
    stroke: "#9594AF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12H20C21.1046 12 22 12.8954 22 14V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V14C2 12.8954 2.89543 12 4 12H6",
    stroke: "#9594AF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5L12 2L15 5",
    stroke: "#9594AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExtractValue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/extract-value.03f43d1f.svg";
export { ForwardRef as ReactComponent };